import { useEffect } from "react";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import HeroCarousel from "./components/HeroCarousel";
import CategoryQuickLinks from "./components/CategoryQuickLinks";
import LatestNews from "./components/LatestNews";
import FeaturedTopics from "./components/FeaturedTopics";
import BrandIntro from "./components/BrandIntro";
import { allArticles, sortArticles } from "@/lib/articles";
import { applyHomeSeo } from "@/lib/seo";

export default function Home() {
  useEffect(() => {
    applyHomeSeo();
  }, []);

  const heroItems = sortArticles(allArticles, "latest").slice(0, 5);

  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <SiteHeader />
      <main className="flex-1 w-full">
        <div className="w-full px-4 md:px-8 pt-6">
          <h1 className="sr-only">鲁啊鲁 - 多元内容展示与资讯平台</h1>
          <HeroCarousel items={heroItems} />
        </div>

        <div className="w-full px-4 md:px-8 mt-12 space-y-14 pb-4">
          <CategoryQuickLinks />
          <LatestNews />
          <FeaturedTopics />
          <BrandIntro />
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}